import React from 'react'
import { Field } from 'formik'
import styled from 'styled-components'
import Checkbox from '../../../../../../Checkbox'
import Label from '../../../../../../Label'

const Container = styled.div`
  display: flex;
  padding: 20px 0;
`

const LabelContainer = styled.div`
  max-width: 300px;
`

const onClick = ({ onChange, name, value }) => () => (
  onChange({
    target: {
      name,
      value: !value,
    },
  })
)

export default () => (
  <Field name='subscribe'>
    {({ field }) => (
      <Container>
        <Checkbox onClick={onClick(field)} {...field} />
        <LabelContainer onClick={onClick(field)}>
          <Label label='Yes! Please email me my results and other useful financial planning info' />
        </LabelContainer>
      </Container>
    )}
  </Field>
)
